import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import RegisterModal from "../.././modals/RegisterModal";
import LoginModal from "../../modals/LoginModal";
import { FaEdit,FaUserTie,FaUserGraduate,FaPlus,FaUserCircle, FaSignOutAlt, FaUser, FaBook } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../../services/axiosInstance"
import ForgotPasswordModal from "../../modals/ForgotPasswordModal ";

const Header = () => {
  const { user, accessToken, logout } = useAuth();
const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get(`/users/get-user-info/${user.id}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        const data = res.data;
        setProfile(data);
      } catch (err) {
        console.error("❌ Failed to fetch profile:", err);
      }
    };

    if (user?.id) fetchProfile();
  }, [user, accessToken]);

  const handleProfile = () => {
    navigate("/profile");
  };

  const isStudent = profile && profile.role === "student";
  const isAdmin = profile && profile.role === "admin";
  
  const GoToCourses = () => {
    isStudent ? navigate("/courses") : navigate("/professor-courses");
  };

  // Function to handle smooth scrolling to sections
  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== "/") {
      navigate("/");
      // Wait for navigation to complete then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // If already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setMenuOpen(false); // Close mobile menu if open
  };

  // Map navigation items to their corresponding section IDs
  const navItems = [
    { label: "Accueil", id: "hero" },
    { label: "Formations", id: "courses" },
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Contact", id: "contact" }
  ];

  return (
    <> 
      {/* Navbar */}
      <nav className="fixed w-full top-0 z-50 bg-black/20 backdrop-blur-md">
  <div className="max-w-7xl mx-auto px-4">
    <div className="flex justify-between items-center h-16">
      {/* Logo */}
      <div className="flex items-center">
        <div className="text-2xl font-bold text-white cursor-pointer" onClick={() => navigate("/")}>
          CTRL+
        </div>
      </div>

      {/* Nav Links - Center aligned */}
      <div className="absolute left-1/2 transform -translate-x-1/2 hidden md:flex space-x-8">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className="text-white hover:text-blue-200 transition font-medium cursor-pointer text-sm md:text-base"
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Auth Buttons / User Menu - Right aligned */}
      <div className="flex items-center space-x-3 md:space-x-4">
        {user ? (
          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="flex items-center gap-2 text-white hover:text-blue-200 transition group"
            >
              <div className="relative">
                <FaUserCircle className="text-2xl md:text-2xl" />
                <div className="absolute -inset-1 rounded-full group-hover:bg-white/10 transition" />
              </div>
              <span className="font-medium hidden sm:inline">{user.name}</span>
            </button>

            {/* Dropdown Menu */}
            {menuOpen && (
              <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-200 z-50 animate-[fadeIn_0.2s_ease] max-h-[70vh] overflow-y-auto">
                  <button
                  onClick={handleProfile}
                  className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700 border-b border-gray-100"
                >
                  <FaUser className="text-gray-400" /> Profile
                </button>
                {!isAdmin ? (
                  <>
                    <button
                      onClick={GoToCourses}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700 border-b border-gray-100"
                    >
                      <FaBook className="text-gray-400" /> My Courses
                    </button>
                    {!isStudent ? (
                      <button
                        onClick={() => navigate('/admin-student-enrolled')}
                        className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700 border-b border-gray-100"
                      >
                        <FaBook className="text-gray-400" /> Stuednts enrolled
                      </button>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    <div className="px-4  text-xs font-semibold text-gray-500 uppercase tracking-wider bg-gray-50">
                      Admin Panel
                    </div>
                    <button
                      onClick={() => window.location.href = '/admin-professors'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaUserTie className="text-gray-400" /> Manage Professors
                    </button>
                    <button
                      onClick={() => window.location.href = '/admin-students'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaUserGraduate className="text-gray-400" /> Manage Students
                    </button>
                    <button
                      onClick={() => window.location.href = '/free-courses'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaBook className="text-gray-400" /> Manage Free Courses
                    </button>
                    <button
                      onClick={() => window.location.href = '/admin-courses-delete'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaBook className="text-gray-400" /> Manage Courses
                    </button>
                    <button
                      onClick={() => window.location.href = '/edit-portfolio'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaEdit className="text-gray-400" /> Edit Portfolio
                    </button>
                    <button
                      onClick={() => window.location.href = '/service'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaEdit className="text-gray-400" /> Edit Service
                    </button>
                    <button
                      onClick={() => window.location.href = '/admin-control-timeline'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaEdit className="text-gray-400" /> Edit timeline
                    </button>
                    <button
                      onClick={() => window.location.href = '/edit-feedback'}
                      className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-gray-700"
                    >
                      <FaEdit className="text-gray-400" /> Edit Feedback
                    </button>
                  </>
                )}
                <button
                  onClick={logout}
                  className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 text-red-600 border-t border-gray-100 mt-1"
                >
                  <FaSignOutAlt /> Logout
                </button>
              </div>
            )}
          </div>
        ) : (
         <div className="flex items-center space-x-3">
  <button
    onClick={() => setIsLoginOpen(true)}
    className="px-3 py-1.5 text-sm 
      text-white/80 hover:text-white
      transition-colors duration-200"
  >
    Login
  </button>
  
  <div className="h-4 w-px bg-white/20" />
  
  <button
    onClick={() => setIsRegisterOpen(true)}
    className="px-3 py-1.5 text-sm font-medium
      text-white border border-white/40 
      hover:border-white/80 rounded
      transition-all duration-200
      hover:bg-white/5"
  >
    Sign Up
  </button>
</div>
        )}
      </div>
    </div>
  </div>
</nav>

      {/* Modals */}
      <RegisterModal
        isOpen={isRegisterOpen}
        onClose={() => setIsRegisterOpen(false)}
        onSwitchToLogin={() => {
          setIsRegisterOpen(false);
          setIsLoginOpen(true);
        }}
      />

      <LoginModal
  isOpen={isLoginOpen}
  onClose={() => setIsLoginOpen(false)}
  onSwitchToRegister={() => {
    setIsLoginOpen(false);
    setIsRegisterOpen(true);
  }}
  onSwitchToForgotPassword={() => {
    setIsLoginOpen(false);
    setIsForgotPasswordOpen(true);
  }}
/>

   
<ForgotPasswordModal
  isOpen={isForgotPasswordOpen}
  onClose={() => setIsForgotPasswordOpen(false)}
  onSwitchToLogin={() => {
    setIsForgotPasswordOpen(false);
    setIsLoginOpen(true);
  }}
/>
    </>
  );
};

export default Header;
